var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0003,
    cy: 12,
    r: 8.27569,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8154 12C20.8154 16.8252 16.8252 20.8154 12 20.8154C7.1748 20.8154 3.18457 16.8252 3.18457 12C3.18457 7.16602 7.16602 3.18457 11.9912 3.18457C16.8252 3.18457 20.8154 7.16602 20.8154 12ZM5.75141 7.52889C5.77182 8.43133 6.40167 9.40535 7.53602 10.402L8.84385 11.5441C8.90856 11.6015 8.96904 11.6536 9.0249 11.7018C9.30019 11.9391 9.46289 12.0793 9.46289 12.2678C9.46289 12.4182 9.38924 12.565 9.30879 12.7253C9.21202 12.9182 9.10542 13.1307 9.10542 13.3925C9.10542 13.8372 9.31467 14.2034 9.76805 14.5347C10.083 14.7729 10.3465 14.9662 10.5655 15.1269C11.2924 15.6603 11.5293 15.8341 11.5293 16.0954C11.5337 16.3918 11.4434 16.6536 11.3546 16.9105C11.2712 17.1521 11.1892 17.3895 11.1892 17.6473C11.1892 18.1094 11.8083 18.6413 12.3575 18.6413C13.4648 18.6413 16.5339 14.6132 16.5339 13.1135C16.5339 12.2765 14.6419 10.6287 13.6654 10.6287C13.4608 10.6287 13.1961 10.7686 12.9204 10.9145C12.6204 11.0733 12.3072 11.239 12.0437 11.239C11.538 11.239 10.3784 10.2537 10.3784 9.8178C10.3784 9.56495 10.6225 9.39057 10.8753 9.39057C11.0585 9.39057 11.3008 9.54032 11.5689 9.70597C11.9007 9.911 12.2719 10.1404 12.6191 10.1404C13.1946 10.1404 13.5259 9.73933 13.5259 9.15517C13.5259 8.87616 13.3776 8.59716 13.1074 8.20481C13.9726 7.76369 15.7211 6.86862 16.3691 5.6802C15.128 4.821 13.6202 4.31836 11.9912 4.31836C9.41287 4.31836 7.13929 5.58283 5.75141 7.52889Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.2a5543d5c0869423e63cc17a9adf8c3e.svg";
export { ForwardRef as ReactComponent };